import { defaultLocale, locales } from './constants';

const isLocale = (lang) => {
  return locales.some((locale) => locale === lang);
};

const getInitialLocale = () => {
  const localSetting = localStorage.getItem('locale');
  if (localSetting && isLocale(localSetting)) {
    return localSetting;
  }

  const [browserSetting] = navigator.language.split('-');
  if (isLocale(browserSetting)) {
    return browserSetting;
  }

  return defaultLocale;
};

export default getInitialLocale;
